import { LandingModelState } from "../models/LandingModel/landing.model";
import apiConvocatorias from "../api/Convocatorias/api-convocatorias";
import { useState } from "react";
import moment from "moment";
import apiMaestras from "../api/Maestras/api-maestras";
import { generarAnios } from "../utils/generateYears";
import { EntidadOptions } from "../utils/dataSelectOptions"

const initialState = {
  todaslasconvocatorias: [],
  convocatoriasslice: [],
  convocatoriasfiltradas: [],
  cantidad: 100,
  incremento: 100,
  perfil: [],
  area: [],
  entidad: [],
  linea_estrategicas: [],
  linea_estrategica: "",
  categoria_linea_convocatoria: "",
  categoria_linea_convocatorias: [],
  palabra_clave: "",
  buscarconvocatorias: {
    perfil_participante: null,
    area: null,
    linea_convocatoria: null,
    categoria_linea_convocatoria: null,
    buscar_palabra_clave: null,
    tipo_convocatoria: null,
    anio: null,
    entidad: null
  },
  anios: []
};

export const useLanding = () => {
  const [principalState, setPrincipalState] = useState<LandingModelState>(initialState);

  const [visibleButton, setVisibleButton] = useState(true);

  const [loadingConvocatorias, setLoadingConvocatorias] = useState<boolean>(true);

  const getConvocatorias = async () => {
    setLoadingConvocatorias(true);
    let { convocatorias } = await apiConvocatorias.getConvocatoriasPublicadas();
    const lineasConvocatorias = await apiMaestras.obtenerLineaConvocatoria();
    const areas: any = await apiMaestras.obtenerAreas();

    let convabiertas: any = [];
    convocatorias.map((data: any) => {
      if (data.estado === "Abierta" || data.estado === "En espera" || data.estado === "En proceso" || data.estado === "Cerrada") {

        convabiertas = [...convabiertas, data];
      }
    });

    convocatorias = convabiertas;
    let inicio = convocatorias.length - principalState.cantidad;
    if (inicio < 0) inicio = 0;
    let convocatoriasslice = convocatorias.slice(inicio, convocatorias.length);

    const arrayAnios = generarAnios();

    setPrincipalState({
      ...principalState,
      todaslasconvocatorias: convocatorias,
      convocatoriasslice,
      categoria_linea_convocatorias: [],
      area: areas,
      linea_estrategicas: lineasConvocatorias,
      anios: arrayAnios,
      entidad: EntidadOptions
    });

    setLoadingConvocatorias(false);
  };

  const getSiguientesConvocatorias = () => {
    let convocatoriasslice = principalState.todaslasconvocatorias;
    let sumarcantidad = principalState.cantidad + principalState.incremento;
    const resultFilter = validateFilterConvocatorias(convocatoriasslice);
    convocatoriasslice = resultFilter.slice(resultFilter.length - (principalState.cantidad + principalState.incremento), resultFilter.length);
    if (sumarcantidad > resultFilter.length) {
      convocatoriasslice = resultFilter.slice(0, resultFilter.length);
      setVisibleButton(false);
    }
    setPrincipalState({ ...principalState, convocatoriasslice, cantidad: sumarcantidad });
  };

  const buscarconvocatorias = () => {
    setLoadingConvocatorias(true);
    principalState.cantidad = principalState.incremento;
    let filtro: any = principalState.todaslasconvocatorias;
    const resultFilter: any = validateFilterConvocatorias(filtro);
    let fin = resultFilter.length - 1;
    let inicio = Math.max(fin - principalState.cantidad + 1, 0);
    let convocatoriasslice = resultFilter.slice(inicio, fin + 1);
    setPrincipalState({
      ...principalState,
      convocatoriasslice
    });

    setLoadingConvocatorias(false);
  };

  const validateFilterConvocatorias = (filtro: any) => {
    if (
      principalState.buscarconvocatorias.perfil_participante &&
      principalState.buscarconvocatorias.perfil_participante !== ""
    ) {
      filtro = filtro.filter((x: any) => {
        for (var i in x.tipo_participante) {
          if (x.tipo_participante[i].value === principalState.buscarconvocatorias.perfil_participante) {
            return x;
          }
        }
      });
    }
    if (principalState.buscarconvocatorias.entidad && principalState.buscarconvocatorias.entidad !== null) {
      filtro = filtro.filter((x: any) => {
        if (x.entidad == principalState.buscarconvocatorias.entidad) {
          return x;
        }
      });
    }
    if (principalState.buscarconvocatorias.area && principalState.buscarconvocatorias.area !== "") {
      filtro = filtro.filter((x: any) => {
        for (var i in x.area) {
          if (x.area[i].value === principalState.buscarconvocatorias.area) {
            return x;
          }
        }
      });
    }
    if (
      principalState.buscarconvocatorias.linea_convocatoria &&
      principalState.buscarconvocatorias.linea_convocatoria !== ""
    ) {
      console.log(filtro)
      filtro = filtro.filter((x: any) => {
        console.log(principalState.buscarconvocatorias.linea_convocatoria)
        if (principalState.buscarconvocatorias.linea_convocatoria == '72') {
          if (x.nombre_convocatoria.includes('jurados')) {
            return x
          }
        }
        if (principalState.buscarconvocatorias.linea_convocatoria == '247') {
          if (x.nombre_convocatoria.includes('BEPS')) {
            return x
          }
        }
        if (x.linea_convocatoria === principalState.buscarconvocatorias.linea_convocatoria) {
          return x;
        }
      });
    }
    if (
      principalState.buscarconvocatorias.categoria_linea_convocatoria &&
      principalState.buscarconvocatorias.categoria_linea_convocatoria !== ""
    ) {
      filtro = filtro.filter((x: any) => {
        for (var i in x.categoria_linea_convocatoria) {
          if (
            x.categoria_linea_convocatoria[i].value === principalState.buscarconvocatorias.categoria_linea_convocatoria
          ) {
            return x;
          }
        }
      });
    }
    if (
      principalState.buscarconvocatorias.buscar_palabra_clave &&
      principalState.buscarconvocatorias.buscar_palabra_clave.trim() !== ""
    ) {
      filtro = filtro.filter((x: any) => {
        if (
          x.nombre_convocatoria
            .toUpperCase()
            .indexOf(principalState.buscarconvocatorias.buscar_palabra_clave.trim().toUpperCase()) > -1
        ) {
          return x;
        }
      });
    }
    if (
      principalState.buscarconvocatorias.tipo_convocatoria &&
      principalState.buscarconvocatorias.tipo_convocatoria !== ""
    ) {
      filtro = filtro.filter((x: any) => x.tipo === principalState.buscarconvocatorias.tipo_convocatoria);
    }

    if (
      principalState.buscarconvocatorias.anio &&
      principalState.buscarconvocatorias.anio !== null
    ) {
      filtro = filtro.filter((x: any) => {
        for (var i in x.fecha_creacion) {
          if (moment(x.fecha_creacion).format('YYYY') === String(principalState.buscarconvocatorias.anio)) {
            return x;
          }
        }
      });
    }
    return filtro;
  }

  const limipiarfiltros = () => {
    /*let infoupdate = { ...principalState.buscarconvocatorias };
    infoupdate.perfil_participante = "";
    infoupdate.area = "";
    infoupdate.entidad = null;
    infoupdate.linea_convocatoria = "";
    infoupdate.categoria_linea_convocatoria = "";
    infoupdate.buscar_palabra_clave = "";
    infoupdate.tipo_convocatoria = "";
    infoupdate.anio = null;
    setPrincipalState({ ...principalState, buscarconvocatorias: infoupdate, convocatoriasslice: principalState.todaslasconvocatorias });*/
    window.location.reload();
  };
  return {
    principalState,
    setPrincipalState,
    getConvocatorias,
    getSiguientesConvocatorias,
    limipiarfiltros,
    buscarconvocatorias,
    visibleButton,
    setVisibleButton,
    setLoadingConvocatorias,
    loadingConvocatorias
  };
};
